var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DesktopMenu"},[_c('div',{staticClass:"DesktopMenu-content"},_vm._l((_vm.menuEntries),function(menuEntry){return _c('menu-item',{key:menuEntry.text,attrs:{"url":menuEntry.url,"text":menuEntry.text}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }